import {useStore} from "effector-react";
import {useEffect, useState} from "react";
import {useFrame} from "react-three-fiber";
import * as THREE from "three";
import {CeprItem} from "../atoms/CeprModel"
import {$modelChoise} from "../../../../common/UI/GuideButtons/logic/GuideLogic";
import {IScene} from "../../../../common/interfaces";
import {ClickMesh} from "../../../../common/UI/ClickMesh/organoids/ClickMesh";

export const Scene = (params: IScene) => {

    const modelChoise = useStore($modelChoise)
    const readenModelSlides = 10
    const [newPosition, ] = useState({x: 0, y: 0, z: 0})
    const [zoom, setZoom] = useState(false)
    // useEffect(() => {

    //     let point = {} as Ipoint3D | undefined

    // }, [params.selected])

    var pos = new THREE.Vector3()

    useFrame((state: { camera: { position: { lerp: (arg0: any, arg1: number) => void; }; updateProjectionMatrix: () => void; }; }) => {
        if (zoom) {
            pos.set(newPosition.x, newPosition.y, newPosition.z)
            state.camera.position.lerp(pos, 0.1)
            state.camera.updateProjectionMatrix()

        }

    });

    useEffect(() => {
        if (zoom) {
            setTimeout(() => {
                setZoom((zoom) => !zoom)
            }, 500)
        }
    }, [zoom])

    useEffect(() => {
        params.setHelper(true)
        setInterval(() => {
            params.setHelper(false)
        }, 8000)
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <>
            <pointLight intensity={1} color="white" position={[1850, 1050, 0]}/>
            <pointLight intensity={1} color="white" position={[0, 1050, -1850]}/>
            <pointLight intensity={1} color="white" position={[-1850, 1050, 0]}/>
            <pointLight intensity={1} color="white" position={[0, 1050, 1850]}/>
            {params.points
                .slice(0, readenModelSlides + 1)
                .map((e, i) => {
                    return <ClickMesh
                        setSelected={params.setSelected}
                        setSelectedHover={params.setSelectedHover}
                        key={i} title={e.text} posX={e.posX} posY={e.posY} posZ={e.posZ} scaleX={0.5} scaleY={0.5}
                        scaleZ={0.5}/>
                })}
            <CeprItem modelChoise={modelChoise}/>
        </>
    )
}